
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 8 8"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M7.637 5.928l-.833-.85a1.241 1.241 0 00-1.369-.229l-.362-.36a2.8 2.8 0 00-.41-3.804A2.824 2.824 0 00.824.822a2.802 2.802 0 001.69 4.775 2.825 2.825 0 001.99-.543l.359.357a1.199 1.199 0 00.213 1.387l.853.85a1.21 1.21 0 001.707 0 1.203 1.203 0 000-1.72zm-3.413-1.7A2.015 2.015 0 01.79 2.808 2 2 0 012.031.958a2.02 2.02 0 012.193.432 2.004 2.004 0 01.437 2.188c-.101.243-.25.465-.437.65zm2.845 2.835a.403.403 0 01-.571 0l-.854-.85a.401.401 0 01.286-.688.404.404 0 01.286.118l.853.85a.4.4 0 010 .57z"}})])
          )
        }
      }
    